import React from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { turkishCurrencyFormatterNoPrecision } from "../utils";

export default function AskQuestionModal(props) {
  const {
    setAnswers,
    questions,
    setQuestions,
    showQuestions,
    setShowQuestions,
    sepeteEkleHandler,
  } = props;

  return (
    <Modal show={showQuestions} onHide={() => setShowQuestions(false)} centered>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        {questions
          .filter((q) => !q.deleted)
          .map((question, qi) => (
            <div key={question._id} className="mb-3">
              <div className="mb-2" style={{ display: "flex" }}>
                <div style={{ width: "30px" }}></div>
                <div>
                  {question.compulsory && (
                    <span className="text-danger " style={{ fontSize: "18px" }}>
                      *&nbsp;
                    </span>
                  )}
                  <span className="text-bold">{question.question}</span>
                </div>
              </div>
              <div>
                {question.answers
                  .filter((a) => !a.deleted)
                  .map((a, ai) => (
                    <div
                      key={a._id}
                      style={{ display: "flex" }}
                      className="mb-2"
                    >
                      <div style={{ maxWidth: "30px" }}>
                        {question.multi ? (
                          <Form.Check
                            inline
                            type="checkbox"
                            checked={a.selected}
                            onChange={(e) => {
                              const qr = [...questions];
                              qr[qi].error = "";
                              qr[qi].answers[ai].selected = e.target.checked;
                              setQuestions(qr);
                            }}
                          />
                        ) : (
                          <Form.Check
                            inline
                            type="radio"
                            checked={a.selected}
                            onChange={() => {}}
                            onClick={(e) => {
                              const qr = [...questions];
                              qr[qi].error = "";

                              const temp = qr[qi].answers[ai].selected;
                              qr[qi].answers.forEach((ans) => {
                                ans.selected = false;
                              });
                              qr[qi].answers[ai].selected = !temp;

                              setQuestions(qr);
                            }}
                          />
                        )}
                      </div>
                      <div>
                        {a.answer}
                        {!!a.firstCost && !!a.cost && a.firstCost > a.cost && (
                          <>
                            &nbsp;&nbsp;
                            <span className="text-bold textDecorationLine text-muted">
                              {turkishCurrencyFormatterNoPrecision(a.firstCost)}
                            </span>
                          </>
                        )}
                        {!!a.cost && (
                          <span className="text-bold">
                            &nbsp;&nbsp;
                            {turkishCurrencyFormatterNoPrecision(a.cost)}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ))}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="light"
          className="text-primary border-primary"
          onClick={() => {
            const qr = questions.map((q) =>
              q.compulsory
                ? q.answers.filter((a) => a.selected).length === 0
                  ? { ...q, error: "En az bir cevap seçmelisiniz!" }
                  : { ...q }
                : { ...q }
            );
            if (qr.filter((q) => q.error).length > 0) {
              toast.error("Lütfen eksik cevapları tamamlayınız!");
            } else {
              sepeteEkleHandler();
            }
          }}
        >
          <i className="fa fa-shopping-cart"></i>&nbsp;
          {"Sepete Ekle"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
